class schedules {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
  static fromJson({ HorarioId, Nombre }) {
    return new schedules(HorarioId, Nombre);
  }
}
export default schedules;
